/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Scholen_Schooljaar_Select_Default_OptionInputs */

const nl_admin_scholen_schooljaar_select_default_option = /** @type {(inputs: Admin_Scholen_Schooljaar_Select_Default_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidig schooljaar`)
};

/**

* @param {Admin_Scholen_Schooljaar_Select_Default_OptionInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const admin_scholen_schooljaar_select_default_option = /** @type {((inputs?: Admin_Scholen_Schooljaar_Select_Default_OptionInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Scholen_Schooljaar_Select_Default_OptionInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_admin_scholen_schooljaar_select_default_option(inputs)
});
export { admin_scholen_schooljaar_select_default_option as "admin.scholen.schooljaar_select.default_option" }